import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PaginatorModule } from 'primeng/paginator';
import { EventComment } from 'src/app/core-module/models/Events/event-comment';

@Component({
  selector: 'app-event-comments',
  standalone: true,
  imports: [CommonModule, FormsModule, PaginatorModule],
  templateUrl: './event-comments.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './event-comments.component.scss'
})
export class EventCommentsComponent {

  @Input() comments: EventComment[] = [];
  @Input() saving: boolean = false;
  @Input() errorMessage: string = '';
  @Input() loading: boolean = false;
  @Output() addComment = new EventEmitter<string>();

  public newCommentText: string = '';
  public warn: boolean = false;
  public pageSize: number = 5;
  public pageIndex: number = 0;

  submit(){
    const trimmed = this.newCommentText?.trim();
    if (!trimmed){
      this.warn = true;
      return;
    }
    this.warn = false;
    this.addComment.emit(trimmed);
    this.newCommentText = '';
  }

  get pagedComments(): EventComment[]{
    const start = this.pageIndex * this.pageSize;
    return this.comments.slice(start, start + this.pageSize);
  }

  onPageChange(event:any){
    this.pageIndex = event.page ?? 0;
    this.pageSize = event.rows ?? this.pageSize;
  }
}
